import styled from 'styled-components'

const Label = styled.label`
  display: block;
  font-weight: 500;
`

export default {
  Label,
}
